const customRange = (start, end) => {
  let count = end.diff(start, 'days') + 1
  return `Custom range (${count} ${count > 1 ? 'days' : 'day'})`
}

export const makeShortcuts = (makeMoment) => ({
  all: {
    key: 'all',
    name: () => 'No dates',
    hideClear: true,
    index: 0,
    make: () => {
      return {
        start: null,
        end: null,
      }
    },
    isMatch: (start, end, availableDates) => {
      if (!start || !end) return true
      return (availableDates && availableDates.start && availableDates.end && availableDates.start.isSame(start, 'days') &&
        availableDates.end.isSame(end, 'days'))
    },
  },
  customRange: {
    key: 'custom',
    name: customRange,
    hidden: true,
    hideClear: false,
    index: 4,
    make: (start, end) => {
      return {
        start,
        end,
      }
    },
    isMatch: (start, end) => {
      if (!start || !end) return false
      return !end.isSame(makeMoment(), 'days')
    },
  },
  today: {
    key: 'today',
    name: () => 'Today',
    hideClear: false,
    index: 5,
    make: (start, end) => {
      return {
        start,
        end,
      }
    },
    isMatch: (start, end) => {
      if (!start || !end) return false
      return start.isSame(end, 'days') && start.isSame(makeMoment(), 'days')
    },
  },
  pastTwoWeeks: {
    key: 'pastTwoWeeks',
    name: () => 'Past two weeks',
    hideClear: false,
    index: 6,
    make: (start, end) => {
      start.add(-14, 'days')
      return {
        start,
        end,
      }
    },
    isMatch: (start, end) => {
      if (!start || !end) return false
      return start.clone().add(14, 'days').isSame(end, 'days')
    },
  },
  pastMonth: {
    key: 'pastMonth',
    name: () => 'Past month',
    hideClear: false,
    index: 7,
    make: (start, end) => {
      start.add(-1, 'months')
      return {
        start,
        end,
      }
    },
    isMatch: (start, end) => {
      if (!start || !end) return false
      return start.clone().add(1, 'months').isSame(end, 'days')
    },
  },
  pastThreeMonths: {
    key: 'pastThreeMonths',
    name: () => 'Past three months',
    hideClear: false,
    index: 8,
    make: (start, end) => {
      start.add(-3, 'months')
      return {
        start,
        end,
      }
    },
    isMatch: (start, end) => {
      if (!start || !end) return false
      return start.clone().add(3, 'months').isSame(end, 'days')
    },
  },
  pastYear: {
    key: 'pastYear',
    name: () => 'Past year',
    hideClear: false,
    index: 9,
    make: (start, end) => {
      start.add(-1, 'years')
      return {
        start,
        end,
      }
    },
    isMatch: (start, end) => {
      if (!start || !end) return false
      return start.clone().add(1, 'years').isSame(end, 'days')
    },
  },
  default: {
    key: 'default',
    name: customRange,
    hidden: true,
    index: 99,
    isMatch: () => true,
  },
})